<script>
import { DefaultEventTicket } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        tickets: []
      },
      singleton: true,
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Formset({
          modelPath: [this, 'form', 'tickets'],
          items: this.form.tickets.map((item, i) => {
            return {
              headerLabel: get(item, ['type_pl']),
              fields: [
                new fields.Input({
                  label: 'Typ',
                  modelPath: [this, 'form', 'tickets', i, 'type'],
                  required: true,
                  multilingual: true
                }),
                new fields.Input({
                  label: 'Rodzaj miejsca',
                  modelPath: [this, 'form', 'tickets', i, 'kind'],
                  required: true,
                  multilingual: true
                }),
                new fields.Input({
                  label: 'Cena',
                  modelPath: [this, 'form', 'tickets', i, 'price'],
                  required: true,
                  multilingual: true
                })
              ]
            }
          })
        })
      ]
    }
  },
  computed: {
    service() {
      return DefaultEventTicket
    }
  }
}
</script>
